// The deposit on an offer is an absolute amount in EUR. Zak. c. 98/2014 Z. z.
// o kratkodobom najme bytu caps it at three times the monthly rent and the
// payments for services, so the ceiling moves whenever those fields change.
export const DEPOSIT_MAX_MONTHS = 3

export const QUICK_FILL_MONTHS = [1, 2, 3] as const

export function depositMaxAllowed(monthlyTotal: number) {
  return round2(monthlyTotal * DEPOSIT_MAX_MONTHS)
}

export function depositMonths(amount: number, monthlyTotal: number) {
  return monthlyTotal ? amount / monthlyTotal : 0
}

export function round2(value: number) {
  return Math.round(value * 100) / 100
}
